<div class="flex column align-items-center gap-32 full-width">
  <div class="flex column align-items-center gap-4">
    <span class="typo-title-3 p-4">Import Wallet</span>
    <span class="typo-text-2 text-medium text-align-center"
      >Pick how you would like to connect your existing wallet.</span
    >
  </div>

  <div class="flex column full-width gap-16">
    @if (!userHasWallets()) {
      <kc-button
        [text]="'Scan QR Code'"
        [prefixIcon]="'icon-qr'"
        [isFullWidth]="true"
        [variant]="'secondary'"
        (buttonClick)="onQrScanClick()"
      />
    }

    @if (!userHasWallets()) {
      <div class="flex align-items-center gap-12 full-width">
        <div class="separator-line"></div>
        <span class="separator-text typo-text-3 text-medium">- OR -</span>
        <div class="separator-line"></div>
      </div>
    }

    <app-import-switch
      class="full-width"
      [selectedMethod]="importMethod()"
      [showImportFromFile]="!userHasWallets()"
      (methodChanged)="onImportMethodChange($event)"
    />
  </div>

  <kc-button
    [isFullWidth]="true"
    [text]="'Continue'"
    (buttonClick)="onContinue()"
  />
</div>
